<template lang="html">
  <div class="account-overview">
    <Header currentMenu="Account" subMenu="Account Overview" />
    <div class="dashboard-content-container gap-64">
      <div class="flex-box page-container">
        <Menu currentMenu="Account Overview" className="desktop-only" />
        <div class="content">
          <BuildPlusRenew @renew-success="reload" />

          <div class="section gray" v-if="!user.enabled_2fa && !loading">
            <div class="black body-17-medium">
              2-Factor authentication (2FA) is not enabled for your account.
              <span class="link-purple" @click="gotoProfilePage">Click here to set it up</span>
              and add an extra layer of security to your account.
            </div>
          </div>

          <div class="section">
            <h2 class="black bgap-48">Account Overview</h2>
            <div v-if="loading">
              <div class="gap-3x" />
              <Spinner />
              <div class="gap-3x" />
            </div>

            <transition name="fade">
              <div v-if="!loading">
                <div class="section-field flex-box wrap">
                  <h3 class="black pull-left bgap-24">General</h3>
                  <div class="field grey pull-right">
                    <label class="descriptor bgap-4">Name</label>
                    <div class="body-17 gray">{{fullName}}</div>
                    <label class="descriptor gap-24 bgap-4">Email</label>
                    <div class="body-17 gray">{{email}}</div>
                    <label class="descriptor gap-24 bgap-4">Organization</label>
                    <div class="body-17 gray">{{$organization.getLocalOrganizationName()}}</div>
                    <span class="link-purple mt-3 body-14" @click="() => this.$router.push('/dashboard/profile')">Edit</span>
                  </div>
                </div>

                <div v-if="products.length > 0" class="section-field flex-box wrap">
                  <h3 class="black pull-left bgap-24">Current subscriptions</h3>
                  <div class="field grey pull-right">
                    <div v-for="product in products" :key="product.product" class="body-17 gray">
                      <div class="gap-24" v-if="products.indexOf(product) > 0" />
                      <div class="body-17-medium black">{{product.product}}</div>
                      <div v-if="!product.expired">
                        <div>{{product.expiration}}</div>
                        <div v-if="product.licenses < 10000">Licenses: {{product.licenses}}</div>
                        <div class="body-14 gap-4">
                          <span class="link-purple" @click="() => gotoProductPage(product)">Edit</span>
                        </div>
                        
                      </div>
                      <div v-if="product.expired">
                        <div class="error-message big bold">Expired</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <SuggestedProducts/>

          <FooterHelper />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'

import Header from '../shares/Header.vue'
import SuggestedProducts from '../shares/SuggestedProducts.vue'
import FooterHelper from '../shares/FooterHelper.vue'
import BuildPlusRenew from '../shares/BuildPlusRenew.vue'
import Menu from '../shares/Menu.vue'
import EventBus from 'src/components/EventBus.js'
import Spinner from 'src/components/common/Spinner.vue'

export default {
  components: { Header, Menu, Spinner, SuggestedProducts, FooterHelper, BuildPlusRenew },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      suggestedProducts: [],
      loading: true,
      user: {}
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
  },
  mounted() {
    this.reload()
  },
  methods: {
    assignUserData(data) {
      this.firstName = data.first_name
      this.lastName = data.last_name
      this.email = data.email
      this.products = data.ownerships
      this.user = data
      this.loading = false
    },
    gotoProductPage(product) {
      this.$router.push(`/dashboard/ownerships?${qs.stringify({ productName: product.product})}`)
    },
    gotoProfilePage() {
      this.$router.push(`/dashboard/profile`)
    },
    reload() {
      this.loading = true
      this.$user.fetchMe();
    }
  },
  computed: {
    fullName() {
      return `${this.firstName || ''} ${this.lastName || ''}`;
    },
  }
}
</script>

<style lang="scss" scoped>
.menu-container, .content {
  height: calc(100vh - 152px);
  overflow-y: auto;
}

.menu-container {
  padding-bottom: 40px;
}

.content {
  span.link-purple {
    display: inline-block;
  }
}

@media screen and (max-width: 768px) {
  .menu-container {
    height: auto;
  }
}
</style>
